<div class="loading" *ngIf="loading">
    <img class="load" src="https://triidyftp.s3.us-east-2.amazonaws.com/Triidy_web/loader.gif" alt="">
</div>

<div class="content" *ngIf="!loading">
    <div class="title-cotizador">
        <div class="title">
            <h1><i class="fas fa-truck"></i>{{ dataEnvio?.estado_general }}</h1>
        </div>
        <div class="guia">
            <p>Número de la guía</p>
            <p><span>{{ id }}</span></p>
        </div>
    </div>
    <div class="row">
        <div class="txt-cent">
            <ul class="tabs">
                <li class="tab">
                    <a [ngClass]="{'active':detalle === true}" (click)="detalleClick()">DETALLE</a>
                </li>
                <li class="tab">
                    <a [ngClass]="{'active':historial === true}" (click)="historialClick()">HISTORIAL</a>
                </li>
            </ul>
        </div>
        <div class="row" *ngIf="detalle">
            <div class="detail-cotizador">
                <h2 class="form-sub">
                    REMITENTE / ORIGEN
                </h2>
                <ul class="list-dates">
                    <li class="l-6">
                        <i class="fas fa-map-marker-alt"></i>
                        <p>Ciudad de recogida</p>
                        <p>
                            <span>{{ dataEnvio?.ciudad_remitente }}</span>
                        </p>
                    </li>
                    <li class="l-6">
                        <i class="fas fa-map-marker-alt"></i>
                        <p>Ciudad de destino</p>
                        <p>
                            <span>{{ dataEnvio?.ciudad_destino }}</span>
                        </p>
                    </li>
                    <li class="l-6">
                        <i class="far fa-calendar-alt"></i>
                        <p>Fecha de entrega</p>
                        <p>
                            <span>{{ dataEnvio?.fecha_entrega }}</span>
                        </p>
                    </li>
                    <li class="l-6">
                        <i class="far fa-clock"></i>
                        <p>Hora de entrega</p>
                        <p>
                            <span>{{ dataEnvio?.hora_entrega }}</span>
                        </p>
                    </li>
                    <li class="l-6">
                        <p>Nombre contacto</p>
                        <p>
                            <span>{{ dataEnvio?.nombre_remitente }}</span>
                        </p>
                    </li>
                    <li class="l-6">
                        <i class="fas fa-map-marker-alt"></i>
                        <p>Dirección</p>
                        <p>
                            <span>{{ dataEnvio?.direccion_remitente }}</span>
                        </p>
                    </li>
                    <li class="l-4">
                        <p>Cantidad de envíos</p>
                        <p>
                            <span>{{ dataEnvio?.cantida_envios }}</span>
                        </p>
                    </li>
                    <li class="l-4">
                        <p>Tipo de producto</p>
                        <p>
                            <span>{{ dataEnvio?.tipo_producto }}</span>
                        </p>
                    </li>
                    <li class="l-4">
                        <p>Peso total (Kg)</p>
                        <p>
                            <span>{{ dataEnvio?.peso_total }}</span>
                        </p>
                    </li>
                    <li class="l-4">
                        <p>Régimen</p>
                        <p>
                            <span>{{ dataEnvio?.regimen }}</span>
                        </p>
                    </li>
                </ul>
                <h2 class="form-sub">
                    DESTINATARIO / DESTINO
                </h2>
                <ul class="list-dates">
                    <li class="l-6">
                        <i class="fas fa-map-marker-alt"></i>
                        <p>Ciudad de recogida</p>
                        <p>
                            <span>{{ dataEnvio?.ciudad_remitente }}</span>
                        </p>
                    </li>
                    <li class="l-6">
                        <i class="fas fa-map-marker-alt"></i>
                        <p>Ciudad de destino</p>
                        <p>
                            <span>{{ dataEnvio?.ciudad_destino }}</span>
                        </p>
                    </li>
                    <li class="l-6">
                        <i class="far fa-calendar-alt"></i>
                        <p>Fecha de entrega</p>
                        <p>
                            <span>{{ dataEnvio?.fecha_entrega }}</span>
                        </p>
                    </li>
                    <li class="l-6">
                        <i class="far fa-clock"></i>
                        <p>Hora de entrega</p>
                        <p>
                            <span>{{ dataEnvio?.hora_entrega }}</span>
                        </p>
                    </li>
                    <li class="l-6">
                        <p>Nombre contacto</p>
                        <p>
                            <span>{{ dataEnvio?.nombre_destinatario }}</span>
                        </p>
                    </li>
                    <li class="l-6">
                        <i class="fas fa-map-marker-alt"></i>
                        <p>Dirección</p>
                        <p>
                            <span>{{ dataEnvio?.direccion_destinatario }}</span>
                        </p>
                    </li>
                </ul>
            </div>
        </div>
        <div class="row" *ngIf="historial">
            <ul class="list_historial">
                <li *ngFor="let nov of history; let i = index" [ngClass]="{'complete': (i+1) >= 2}">
                    <span>{{ i + 1 }}</span>
                    <div class="detalle_hist">
                        <p>
                            <b>{{ nov.Fecha }}</b>
                        </p>
                        <p>{{ nov.Movimiento }}</p>
                    </div>
                    <div class="hora_hist">
                        <p>
                            <b>{{ nov.Hora }}</b>
                        </p>
                    </div>
                </li>
            </ul>
        </div>
    </div>
</div>